import {IStatus, StatusResponseType} from "@/entity/status/status.types";

export default class Status implements IStatus {
    id: number;
    name: string;
    color?: string;
    constructor(data: StatusResponseType) {
        this.id = data.id;
        this.name = data.name;
        switch (this.id) {
            case 1: this.color = 'green'; break;
            case 2: this.color = 'red'; break;
            case 3: this.color = 'orange'; break;
            case 4: this.color = 'blue'; break;
        }
    }
}